import { map, share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Observable, of } from 'rxjs';

export interface Subfleet {
  id: number;
  name: string;
  tail_ids: any[];
  tails: any[];
}

@Injectable({ providedIn: 'root' })
export class SubfleetsService {
  path: string = '/api';
  subfleets: Subfleet[] | null = null;
  partnerId: number | null = null;
  constructor(private apiService: ApiService) { }

  private observable: Observable<Subfleet[]> | null = null;

  getSubfleets(partnerId: number): Observable<Subfleet[]> {
    if (partnerId === this.partnerId && this.subfleets) {
      return of(this.subfleets);
    } else if (this.observable) {
      return this.observable;
    } else {
      this.observable = this.apiService.get<Subfleet[]>(`${this.path}/partners/${partnerId}/subfleets`).pipe(
        map((response: Subfleet[]) => {
          this.observable = null;
          this.partnerId = partnerId;
          this.subfleets = response;
          return this.subfleets;
        }),
        share(),
      );
      return this.observable;
    }
  }
}
